export default "__VITE_ASSET__CgfaKvxE__"